import * as React from 'react';

import { Modal, Stack } from 'react-bootstrap';

import { ICollabModalProps } from './CollabModalContext';

export interface ISaveReportNoticeModalData {
    onSaveClick: (suppressNotice: boolean) => void;
    onCancelClick: () => void;
}

export function SaveReportNoticeModal(
    props: ICollabModalProps<ISaveReportNoticeModalData, unknown>
) {
    if (!props.open) return null;

    const [suppressNotice, setSuppressNotice] = React.useState<boolean>(false);

    const handleSuppressNoticeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSuppressNotice(event.target.checked);
    };

    const handleSaveClick = () => props.data?.onSaveClick(suppressNotice);
    const handleCancelClick = () => props.data?.onCancelClick();

    return (
        <>
            <Modal centered size="lg" show={props.open} backdrop={true}>
                <Modal.Header>
                    <Modal.Title>Save Report</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        When you SAVE a draft or a final draft report, you are saving the settings, selections, and
                        comments for that report - you are NOT saving the case data you are viewing
                        at the time; when you or another collab user open the saved draft, the view
                        will display the last saved settings, selections and comments and the
                        current case data.
                    </p>
                    <p>
                        When a report is in published status, the displayed case data
                        is saved (so updated case data will not be displayed in the report).
                    </p>
                    <p>
                        Note you can always update case data to display current data while you're
                        working in the report by clicking the REFRESH button.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Stack
                        direction="horizontal"
                        style={{ justifyContent: 'space-between', width: '100%' }}
                    >
                        <div>
                            <label style={{ cursor: 'pointer' }}>
                                <input
                                    name="chkEasyUpdate"
                                    type="checkbox"
                                    className="form-check-input"
                                    onChange={handleSuppressNoticeChange}
                                    checked={suppressNotice}
                                />
                                &nbsp;Hide this popup for this report
                            </label>
                        </div>
                        <div>
                            <button className="btn btn-orange" onClick={handleSaveClick}>
                                Save
                            </button>
                            <button className="btn btn-default" onClick={handleCancelClick}>
                                Cancel
                            </button>
                        </div>
                    </Stack>
                </Modal.Footer>
            </Modal>
        </>
    );
}
